import React from 'react'
import Button from '../../../../_library/Button'
import { Form, Formik } from 'formik'
import { showAxiosError, showSuccessMessage } from '../../../../utils/messenger'
import Field from '../../../../_library/Field'
import { setSeatsIoData } from '../../../../../_common/core/http_services/seatsio'
import Select from '../../../../_library/Select'

export const SeatsIoMapManager = ({ eventId, fetchSeatData, setShowModalAttachEvent }) => (
  <div>
    <Formik
      initialValues={{
        chartKey: '',
        chartName: '',
        eventType: 'event',
        eventName: null,
      }}
      validate={values => {
        const errors = {}
        if (!values.chartKey) {
          errors.chartKey = 'Required'
        }
        if (!values.chartName) {
          errors.chartName = 'Required'
        }
        return errors
      }}
      onSubmit={async values => {
        try {
          await setSeatsIoData({
            eventId,
            chartKey: values.chartKey,
            chartName: values.chartName,
            name: values.eventName,
            type: values.eventType,
          })
          setShowModalAttachEvent(false)
          showSuccessMessage('Event linked successfully!')
          await fetchSeatData(eventId)
        } catch (e) {
          showAxiosError(e?.message)
        }
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
        <Form>
          <div className="col-xs-6 col-12">
            <Field
              id="chartKey"
              label="Chart Key"
              value={values.chartKey}
              error={errors.chartKey}
              touched={touched.chartKey}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          <div className="col-xs-6 col-12">
            <Field
              id="chartName"
              label="Chart Name"
              value={values.chartName}
              error={errors.chartName}
              touched={touched.chartName}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          <div className="col-xs-6 col-12">
            <Select
              id="eventType"
              label="Event type"
              options={[
                { value: 'event', label: 'Single day event' },
                { value: 'season', label: 'Multi day event' },
              ]}
              value={values.eventType}
              error={errors.eventType}
              touched={touched.eventType}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </div>
          {values?.eventType === 'season' && (
            <div className="col-xs-6 col-12">
              <Field
                id="eventName"
                label="Name of the main seat map"
                value={values.eventName ?? ''}
                error={errors.eventName}
                touched={touched.eventName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <small>This seat map is able to book across all days of your event</small>
            </div>
          )}
          <Button className="btn btn-primary btn-shadow" type="submit" loading={isSubmitting}>
            <span>Set Event</span>
          </Button>
          <div className="div-spacing-20" />
        </Form>
      )}
    </Formik>
  </div>
)
